//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ExternalNotificationSharedTaskRefactor: FeatureFlag = {"Id":"ExternalNotificationSharedTaskRefactor","Label":"(KILL)[10.27]ExternalNotificationSharedTaskRefactor","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Use shared external notification send task instead of DFExternalNotification-local task implementation.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
